import { Button, Grid, SxProps, Theme } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save'; // Importa el ícono de Save

export type SingleSaveButtonProps = {
  onSave: any;
  saveButtonLabel?: string;
  sxGridItem?: SxProps<Theme>;
};

const SingleSaveButton: React.FC<SingleSaveButtonProps> = ({
  onSave,
  saveButtonLabel = 'Guardar',
  sxGridItem = {
    pt: 3,
    pr: 1,
  },
}) => {
  return (
    <Grid item container justifyContent="flex-end" sx={sxGridItem}>
      <Button onClick={onSave} variant="outlined" startIcon={<SaveIcon />}>
        {saveButtonLabel}
      </Button>
    </Grid>
  );
};

export default SingleSaveButton;